/* ---------------------------------------------------------------------------
   BOULDER BLOCK — FREE GIFTS, GUARANTEED BY THE THEME   (v2.5.1-ab, 2026-10-18: the gift-ladder A/B, cg-split
   test `gift-ladder-1018`). ARM A (control, and everyone when the test isn't running, is killed, a bot, or opted
   out) = v2.3.1 EXACTLY (T-0208, see the v2.3.1 block below; it applies to both arms): one of each gift per block, the pumpkin per block from 2, the code from 1 block, the app's
   embeds do their usual thing. ARM B = the ladder below (v2.4): per ORDER, and app-added gifts are trimmed to it.
   The arm: window.CGAB (the split's head script: cookie + kill list) → the cart attribute _cg_ab → A.
   QA on a draft: ?cg_gl_arm=A|B (session) forces it without the split (the test isn't configured until start).
   v2.4 GIFT LADDER (Julian + Stefano, 10-18): gifts are per ORDER, not per block.
     1 block  = no gifts · 2 blocks = Challenge Cards + Travel Bag + Pumpkin Hold (1 each)
     3+ blocks = Cards + Bag + Finger Gripper + Pumpkin Hold (1 each).  TIERS below; the PDP
     tiles (custom_liquid_free_gifts, gift_tiers) must say the same thing.
   🔴 Needs the Tek Labs app embeds OFF on the theme that loads it (the app adds 1 gift per
     block on its own and would fight this). The app's "Limited Time Offer" code still zeroes
     the gifts: it zeroes up to one of each gift per block, and 1 per order is always within that.
   See pdp/free_gift_race.md. v2.2 adds SEASONAL $0 gifts (ZGIFTS), see the
   block above ZGIFTS. v2.3: a ZGIFT can carry `min` blocks (the pumpkin = 2+ only,
   Julian 10-16). Everything about the 3 app gifts is unchanged from v2.1.
   v2.3.1 (T-0208): the pumpkin is right after EVERY cart write. Two live bugs:
     - excess: MAX_WRITES (8 per page view) silenced the whole script, so after the
       cap the drawer's + / − on the pumpkin (and on the block) stayed uncorrected
       (live repro 10-18: 4 pumpkins on 1 block). ZGIFT-only fixes now have their own
       budget, refilled by every foreign cart write, so the cap still stops a fight
       with the app but never leaves the pumpkin wrong.
     - missing: the Zipify OCU pre-checkout popup ("Add to order") adds the 2nd block
       with an XHR to /cart/add.js?ocu that never reaches our XHR hook (OCU keeps its
       own copy of XMLHttpRequest.prototype.send and restores it on checkout), then
       POSTs checkout_offers/accept and leaves for /checkout. Nothing re-ran, so the
       pumpkin never came (every missing-pumpkin order 10-17/18 carried _ocu_offer_id;
       live repro 10-18: OCU cart at $89.60 with 2 blocks, 0 pumpkins). Now the accept
       response is held (max HOLD_MS) until a gift pass has run, so OCU navigates only
       after the pumpkin is in; and XHR cart writes are also caught from the resource
       timeline, so a write that bypasses the hook still triggers a pass.
     - the drawer's qty controls and remove button are hidden on ZGIFT lines.

   Tek Labs Gifts & Upsell (Salepify) adds the 3 gifts AND applies its code
   "Limited Time Offer" from an engine that boots 6-16 s after the page. A shopper
   who adds to cart first gets neither, and the app never retries: 109 of 1,977
   Boulder Block orders 09-14 → 09-21 had no gifts and no code (100% correlated).

   v1 (08-28) replaced the app and was reverted. v2 does not fight the app, it
   MIRRORS it: the same variant, the same line property, the same code. Shopify
   merges identical lines, and the app treats lines carrying its property as its
   own, so whichever actor is first, the cart ends up the same.

   The 100%-off is Tek Labs' Function discount "Limited Time Offer" (code,
   combines with everything). Measured on live carts 2026-09-22:
     - gifts with the property but WITHOUT the code are CHARGED
     - the code zeroes exactly one of each gift per Boulder Block; extras are
       split off and CHARGED  → gift qty must equal block qty, never more
     - with no Boulder Block the code is "not applicable" and gifts are CHARGED
       → gift lines must leave the cart with the last block
   So this keeps, after every cart write: each gift = block count, the code on
   the cart while a block is in it, and never touches a gift SKU the shopper
   bought on its own (no property = a paid line).
--------------------------------------------------------------------------- */
(function () {
  "use strict";
  var VERSION = "2.5.2-ab";
  var TEST = "gift-ladder-1018";
  // "test": only sessions opened with ?cg_gifts=1 · "on": every visitor · "off": nobody
  var MODE = "on";

  var BLOCK = 50633696051526;
  var GIFTS = [55110017417542, 49214012195142, 56856060887366];
  var PROP  = "_salepify-advanced-fg", RULE = "17946";
  var CODE  = "Limited Time Offer";
  /* v2.4: the fewest blocks in the cart that earn ONE of each gift (per order) */
  var TIERS = {};
  TIERS[55110017417542] = 2;   // Challenge Cards
  TIERS[56856060887366] = 2;   // Travel Canvas Bag
  TIERS[49214012195142] = 3;   // Silicone Finger Gripper
  var ladder = false;   // set per sync from the arm
  function wantGift(v, blocks) { return ladder ? (blocks >= (TIERS[v] || 1) ? 1 : 0) : blocks; }
  function armFrom(str) { var m = new RegExp("(?:^|\\|)" + TEST + ":([A-Z])").exec(str || ""); return m ? m[1] : ""; }
  function killed() {
    try { var k = JSON.parse(localStorage.getItem("cgab_k") || "null"); return !!(k && k.k && k.k.indexOf(TEST) > -1); }
    catch (e) { return false; }
  }
  function resolveArm(cart) {
    try { var o = sessionStorage.getItem("cg_gl_arm"); if (o === "A" || o === "B") return o + ":qa"; } catch (e) {}
    var P = window.CGAB;
    if (!P) return "A:no-split";
    if (P.bot || P.out) return "A:bot-or-out";
    if (killed()) return "A:killed";
    if (P.arms && P.arms[TEST]) return P.arms[TEST] + ":cgab";
    var a = armFrom(cart && cart.attributes && cart.attributes._cg_ab);
    return a ? a + ":attr" : "A:none";
  }
  window.__cgGiftArm = resolveArm;   // for tests
  /* the cart drawer's progress bar per arm, on every page (the split's own hide CSS only runs on the test's page):
     today's bar (checkpoints_bar_wfTNhT) unless the arm is B, then the ladder's (checkpoints_bar_ladderB) */
  var GL_CSS = 'html:not([data-cg-gl="B"]) [class*="__checkpoints_bar_ladderB"]{display:none!important}' +
               'html[data-cg-gl="B"] [class*="__checkpoints_bar_wfTNhT"]{display:none!important}';
  function markArm(arm) {
    try {
      if (!document.getElementById("cg-gl-css")) {
        var st = document.createElement("style"); st.id = "cg-gl-css"; st.textContent = GL_CSS;
        (document.head || document.documentElement).appendChild(st);
      }
      document.documentElement.setAttribute("data-cg-gl", arm.charAt(0));
    } catch (e) {}
  }
  var MAX_WRITES = 8;                        // per page view — a guard against ping-pong
  /* v2.3.1: ZGIFT-only fixes don't spend MAX_WRITES; they spend this budget, which only
     a foreign cart write refills (nothing else writes a ZGIFT, so there is no ping-pong) */
  var zbudget = 2, ZBUDGET_MAX = 6;
  var HOLD = /\/checkout_offers\/accept(?:\?|$)/, HOLD_MS = 2500;   // the OCU popup's accept: held until the gifts are right

  /* v2.2 — SEASONAL $0 GIFTS (the in-house road, inhouse_gifts_plan.md). A ZGIFT is a
     hidden, not-for-sale product priced 0.00 (same warehouse SKU), so no app rule and no
     code is involved: the discount engine never touches it. Same quantity rule as the app
     gifts: one per Boulder Block, the lines leave with the last block. Each one carries
     `until` (UTC ms): after it, its lines are removed from any cart, so the gift rolls
     off on time even if nobody edits this file. ZMODE: "off" · "test" (only sessions
     opened with ?cg_zgifts=1) · "on". ?cg_zgifts=0 turns it off for a session.
     v2.3: `min` = the fewest blocks that earn it (below it the lines leave the cart). */
  var ZMODE = "on";
  var ZGIFTS = [
    // FREE GIFT · Pumpkin Hold (Halloween Limited Edition), SKU CG-BB-PUMPKIN, until Sun 1 Nov 00:00 PT,
    // only with 2+ blocks (one per block from 2), Julian 2026-10-16
    { v: 57607567180102, until: Date.UTC(2026, 10, 1, 7, 0, 0), min: 2 }
  ];
  var ZPROP = "_cg_gift";

  try {
    var qa = new URLSearchParams(location.search).get("cg_gl_arm");
    if (qa === "A" || qa === "B") sessionStorage.setItem("cg_gl_arm", qa);
    if (qa === "off") sessionStorage.removeItem("cg_gl_arm");
  } catch (e) {}
  try {
    var q = new URLSearchParams(location.search).get("cg_gifts");
    if (q === "1" || q === "0") sessionStorage.setItem("cg_gifts", q);
    var s = sessionStorage.getItem("cg_gifts");
    if (s === "0") MODE = "off";
    else if (s === "1" && MODE === "test") MODE = "on";
  } catch (e) {}
  try {
    var zq = new URLSearchParams(location.search).get("cg_zgifts");
    if (zq === "1" || zq === "0") sessionStorage.setItem("cg_zgifts", zq);
    var zs = sessionStorage.getItem("cg_zgifts");
    if (zs === "0") ZMODE = "off";
    else if (zs === "1" && ZMODE === "test") ZMODE = "on";
  } catch (e) {}
  var diag = window.__cgGifts = { version: VERSION, mode: MODE, zmode: ZMODE, writes: 0, zwrites: 0, log: [] };
  markArm(resolveArm(null));
  if (MODE !== "on") return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var origFetch = window.fetch.bind(window);
  var running = false, again = false, againFull = false, timers = [], idle = [];

  function note(m) { diag.log.push(Math.round(performance.now()) + "ms " + m); }
  function api(path, body) {
    return origFetch(root + path, body
      ? { method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(body) }
      : { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error(path + " " + r.status); return r.json(); });
  }
  function zgift(id) { for (var n = 0; n < ZGIFTS.length; n++) if (ZGIFTS[n].v === id) return ZGIFTS[n]; return null; }
  function isOurs(item) {
    return GIFTS.indexOf(item.variant_id) > -1 && item.properties && String(item.properties[PROP]) === RULE;
  }

  /* full=false is the quick pass right after a cart write: it only ADDS what is
     missing, trims extras and applies the code. It never clears gift lines from a
     cart with no block, because the app adds its gifts in parallel with the block
     and they briefly land first, and a slow block add can take >3 s (live test
     09-22). full=true (load, the 8 s re-check, checkout click) also clears gifts left behind in a block-less cart, where the
     code is "not applicable" and they would be charged. */
  function sync(why, full) {
    if (running) { again = true; againFull = againFull || !!full; return null; }
    var capped = diag.writes >= MAX_WRITES;
    if (capped && zbudget <= 0) { note("write cap reached, stopping (" + why + ")"); return null; }
    running = true;
    return api("cart.js").then(function (cart) {
      var arm = resolveArm(cart); ladder = arm.charAt(0) === "B"; diag.arm = arm; markArm(arm);
      var blocks = 0, byVariant = {};
      cart.items.forEach(function (i) {
        if (i.variant_id === BLOCK) blocks += i.quantity;
        if (isOurs(i)) (byVariant[i.variant_id] = byVariant[i.variant_id] || []).push(i);
      });

      var add = [], updates = {}, touched = false, zadd = [], zupdates = {}, ztouched = false;

      /* seasonal $0 gifts: any line of a ZGIFT variant is ours (the product is not for sale) */
      var now = Date.now();
      ZGIFTS.forEach(function (z) {
        var lines = cart.items.filter(function (i) { return i.variant_id === z.v; });
        var have = lines.reduce(function (n, l) { return n + l.quantity; }, 0);
        var want = (ZMODE === "on" && now < z.until && blocks >= (z.min || 1)) ? (ladder ? 1 : blocks) : 0;   // B: one per order
        if (have === want && lines.length <= 1) return;
        /* unlike the app gifts, nothing else ever adds a ZGIFT ahead of the block, so it can leave at once */
        if (!lines.length) {
          if (want > 0) zadd.push({ id: z.v, quantity: want, properties: (function () { var p = {}; p[ZPROP] = "1"; return p; })() });
          return;
        }
        lines.forEach(function (l, n) { zupdates[l.key] = n === 0 ? want : 0; ztouched = true; });
      });

      GIFTS.forEach(function (v) {
        var lines = byVariant[v] || [];
        var have = lines.reduce(function (n, l) { return n + l.quantity; }, 0);
        var want = wantGift(v, blocks);
        if (have === want && lines.length <= 1) return;
        if (blocks === 0 && !full) return;
        if (!lines.length) {
          if (want > 0) add.push({ id: v, quantity: want, properties: (function () { var p = {}; p[PROP] = RULE; return p; })() });
          return;
        }
        lines.forEach(function (l, n) { updates[l.key] = n === 0 ? want : 0; touched = true; });
      });

      var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
      var hasCode = codes.some(function (c) { return String(c).toLowerCase() === CODE.toLowerCase(); });
      /* v2.5.2: the code from 1 block in BOTH arms (arm A = v2.3.1). 10-18 gate: with B adding it only at 2 blocks, the
         code write landed at the same moment as OCU's OCU40 and AU's arm-B OCU taker lost OCU40 (A$164.80 vs 131.84).
         At 1 block in B it is simply "not applicable" (no gift lines), as the app already leaves it today. */
      var needCode = blocks > 0 && !hasCode;

      var zfix = zadd.length > 0 || ztouched, afix = add.length > 0 || touched || needCode;
      if (!zfix && !afix) { note("ok (" + why + ") blocks=" + blocks); return; }
      if (afix && capped) {   /* past the cap: the app gifts and the code are left alone, the ZGIFTs still get fixed */
        if (!zfix) { note("write cap reached, stopping (" + why + ")"); return; }
        add = []; updates = {}; touched = false; needCode = false; afix = false;
      }
      if (!afix && zbudget > 0) { zbudget--; diag.zwrites++; }
      else if (!capped) diag.writes++;
      else { note("write cap reached, stopping (" + why + ")"); return; }
      add = add.concat(zadd);
      Object.keys(zupdates).forEach(function (k) { updates[k] = zupdates[k]; touched = true; });
      note("fix (" + why + ") arm=" + arm + " blocks=" + blocks + " add=" + add.length + " qty=" + Object.keys(updates).length + " code=" + needCode);

      var p = add.length ? api("cart/add.js", { items: add }) : Promise.resolve();
      return p.then(function () {
        var body = {};
        if (touched) body.updates = updates;
        if (!needCode) return Object.keys(body).length ? api("cart/update.js", body) : null;
        if (!ladder) {   // arm A: v2.3 exactly
          body.discount = codes.concat([CODE]).join(",");
          return api("cart/update.js", body);
        }
        /* v2.4: re-read the codes right before writing them. With the app's embed off this script is the one adding
           the code, at the moment the 2nd block lands, which is when the OCU app applies OCU40: merging the codes read
           at the start of the pass dropped OCU40 in the 10-18 draft test (total 111.99 instead of 89.60). */
        return api("cart.js").then(function (fresh) {
          var now = (fresh.discount_codes || []).map(function (d) { return d.code; });
          /* plus the codes another script's write just asked for (it may still be in flight) */
          foreignCodes.forEach(function (c) { if (now.every(function (x) { return x.toLowerCase() !== c.toLowerCase(); })) now.push(c); });
          if (now.some(function (c) { return String(c).toLowerCase() === CODE.toLowerCase(); })) {
            return Object.keys(body).length ? api("cart/update.js", body) : null;
          }
          body.discount = now.concat([CODE]).join(",");
          return api("cart/update.js", body);
        });
      }).then(refreshDrawer);
    }).catch(function (e) { note("error " + (e && e.message)); })
      .then(function () {
        running = false;
        if (again) { var f = againFull; again = false; againFull = false; sync("queued", f); }
        if (!running) { var w = idle; idle = []; w.forEach(function (r) { r(); }); }
      });
  }

  /* v2.3.1: resolves when no pass is running or queued; settle() runs one more pass and waits for it */
  function whenIdle() { return running ? new Promise(function (r) { idle.push(r); }) : Promise.resolve(); }
  function settle(why) { return whenIdle().then(function () { return sync(why, false) || whenIdle(); }); }

  /* The drawer does not redraw for writes it didn't make (live test 09-22: cart held
     8 items, drawer still said "2 items"). Re-render it the way the theme does:
     the Section Rendering API for the sections the drawer itself declares. */
  function refreshDrawer() {
    try {
      var d = document.querySelector("cart-drawer");
      if (!d || !d.getSectionsToRender || !d.getSectionInnerHTML) return;
      var secs = d.getSectionsToRender();
      return origFetch(root + "?sections=" + secs.map(function (x) { return x.id; }).join(","), { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (html) {
          secs.forEach(function (x) {
            var el = x.selector ? document.querySelector(x.selector) : document.getElementById(x.id);
            if (el && html[x.id] != null) el.innerHTML = d.getSectionInnerHTML(html[x.id], x.selector);
          });
        }).catch(function (e) { note("drawer refresh failed " + (e && e.message)); });
    } catch (e) { note("drawer refresh failed " + (e && e.message)); }
  }

  /* after a cart write that isn't ours: act almost at once, then re-check twice.
     Do NOT wait for the app: window.tlFreeGiftOffer exists long before the app
     works (live test 09-22: present at 0.8 s, no gifts by 5.4 s), and when it does
     add, its gifts sit CHARGED until its code lands (~15 s). A double add merges
     into one line (same variant + property); the re-checks set it back to 1 per block. */
  function afterWrite(src) {
    zbudget = Math.min(zbudget + 2, ZBUDGET_MAX);
    timers.forEach(clearTimeout);
    timers = [setTimeout(function () { sync(src, false); }, 300),
              setTimeout(function () { sync(src + " recheck3s", false); }, 3000),
              setTimeout(function () { sync(src + " recheck8s", true); }, 8000)];
  }

  var WRITE = /\/cart\/(add|change|update)(\.js)?(\?|$)/;
  /* v2.4: the code list the latest foreign cart write asked for (Shopify's `discount` REPLACES the list, so a write
     that races ours must not lose it: the OCU app's OCU40 lands with the 2nd block, exactly when we add the code) */
  var foreignCodes = [];
  function noteCodes(body) {
    try {
      var d = null;
      if (typeof body === "string") {
        if (body.charAt(0) === "{") d = JSON.parse(body).discount;
        else { var m = /(?:^|&)discount=([^&]*)/.exec(body); if (m) d = decodeURIComponent(m[1].replace(/\+/g, " ")); }
      } else if (body && typeof FormData !== "undefined" && body instanceof FormData) d = body.get("discount");
      if (d != null) foreignCodes = String(d).split(",").map(function (c) { return c.trim(); })
        .filter(function (c) { return c && c.toLowerCase() !== CODE.toLowerCase(); });
    } catch (e) {}
  }
  window.fetch = function (input) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    if (WRITE.test(url) && arguments[1]) noteCodes(arguments[1].body);
    var p = origFetch.apply(window, arguments);
    if (HOLD.test(url)) {
      /* v2.3.1: OCU has just added its block (by an XHR we can't hook) and leaves for /checkout as soon as this
         resolves: hand it the response only once a gift pass has run (or after HOLD_MS, never blocking checkout) */
      return p.then(function (r) {
        afterWrite("ocu-accept");
        var cap = new Promise(function (ok) { setTimeout(ok, HOLD_MS); });
        return Promise.race([settle("ocu-accept"), cap]).then(function () { return r; }, function () { return r; });
      });
    }
    if (WRITE.test(url)) p.then(function () { afterWrite("fetch"); }).catch(function () {});
    return p;
  };
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__cgUrl = u; return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (b) {
    if (typeof this.__cgUrl === "string" && WRITE.test(this.__cgUrl)) {
      noteCodes(b);
      this.addEventListener("load", function () { afterWrite("xhr"); });
    }
    return xs.apply(this, arguments);
  };

  /* v2.3.1: an XHR cart write that went around the hook above (Zipify OCU) still shows up in the resource timeline */
  try {
    new PerformanceObserver(function (l) {
      l.getEntries().forEach(function (e) { if (e.initiatorType === "xmlhttprequest" && WRITE.test(e.name)) afterWrite("xhr-seen"); });
    }).observe({ type: "resource" });
  } catch (e) {}

  /* a head start when they head for checkout (never blocks the click) */
  document.addEventListener("pointerdown", function (e) {
    var t = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"], button[form*="cart"]');
    if (t) { zbudget = Math.min(zbudget + 1, ZBUDGET_MAX); sync("checkout-click", true); }
  }, true);

  /* v2.3.1: no qty controls and no remove on a ZGIFT line in the cart drawer / cart page (the + / − there was
     the excess pumpkins' door; the count is ours to set). Pure CSS keyed on the line's variant id. */
  if (ZMODE === "on") try {
    var zsel = ZGIFTS.map(function (z) { return '.cart-item:has(input[data-quantity-variant-id="' + z.v + '"])'; });
    var st = document.createElement("style"); st.id = "cg-zgift-lock";
    st.textContent = zsel.map(function (s) { return s + " .quantity__button," + s + " cart-remove-button"; }).join(",") +
      "{display:none!important}" + zsel.map(function (s) { return s + " quantity-input"; }).join(",") + "{pointer-events:none}";
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}

  /* repair a cart that arrives already missing its gifts (a reload, a recovery link) */
  function boot() { sync("load", true); setTimeout(function () { sync("load recheck", true); }, 7000); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  window.addEventListener("pageshow", function (e) { if (e.persisted) sync("bfcache", true); });
})();
